import React from 'react';
import Header from './Header';
import HeroCarousel from './HeroCarousel';
import PostHeroAbout from './PostHeroAbout';
import AreaOfWork from './AreaOfWork';

import Footer from './Footer';

const Home: React.FC = () => {
    return (
        <div className="space-y-0">
            <Header />
            <HeroCarousel />
            <PostHeroAbout />
            <AreaOfWork />

            <Footer />
        </div>
    );
};

export default Home;